var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KDSList'),_vm._v(" "),(_vm.isAdmin)?_c('KdsAdminDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }